




























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import SieMeta from '@/views/SieMeta.vue';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import { CompanySie } from '../store/models';
import * as api from '@/store/api';
import axios from 'axios';

@Component({ components: { SieMeta } })
export default class CardSie extends CompanyMixin {
  selectedModel: any = {};

  @Watch('sies', { immediate: true, deep: true })
  onSiesChanged() {
    if (this.sies && !this.selected) {
      if (user.selectedSie) {
        for (const sie of this.sies) {
          if (sie.SieId === user.selectedSie) {
            this.selectedModel = sie;
            break;
          }
        }
      } else if (this.sies.length > 0) {
        this.selectedModel = this.sies[0];
      }
    }

    if (
      user.activeSie &&
      this.selected &&
      user.activeSie.SieId === this.selected.SieId &&
      user.activeSie.Id !== this.selected.Id
    ) {
      user.setActiveSie(this.selected);
    }
  }

  @Watch('selected', { immediate: true, deep: true })
  async onSelectionChanged() {
    if (this.selected) {
      await user.setSelectedSie(this.selected.SieId);
      await user.setSelectedSieBlob(this.selected.Id);
    }
  }

  activateSie() {
    if (this.isActive) {
      user.setActiveSie(null);
    } else {
      user.setActiveSie(this.selected);
    }
  }

  editSie() {
    if (!this.selected) {
      return;
    }
    this.$router.push({ name: 'editsie' });
  }

  async deleteSie() {
    const res = await this.$bvModal.msgBoxConfirm('Vill du ta bort SIE?', {
      title: 'Bekräftelse',
      okTitle: 'Ja',
      cancelTitle: 'Nej',
      buttonSize: 'lg',
      okVariant: 'success',
      headerClass: 'p-2 border-bottom-0',
      footerClass: 'p-2 border-top-0',
      centered: true,
    });
    if (res && user.selectedSie) {
      await api.deleteSie(user.selectedSie);
      await user.setSelectedSie(null);
      await user.setSelectedSieBlob(null);
      this.selectedModel = {};
      await user.getUser('Tar bort SIE');
    }
  }

  download(template: string, fileName: string) {
    user.setFetchingData(true);
    user.setFetchingMessage('Genererar PDF...');

    axios({
      method: 'get',
      url: this.targetUri(template),
      responseType: 'arraybuffer',
    })
      .then((response) => {
        user.setFetchingData(false);
        this.forceFileDownload(response, fileName);
      })
      .catch(() => {
        user.setFetchingData(false);
        console.log('an error occurred');
      });
  }

  targetUri(template: string) {
    const u = user.user;
    if (!u || !this.overview || !this.selected) {
      return;
    }
    return `/api/pdf/quick/accounting/${u.UserId}/${u.Version}/${
      this.overview.OrgNr
    }/${this.selected.AggVersion}`;
  }

  forceFileDownload(response: any, fileName: string) {
    const data = new Blob([response.data], { type: 'application/pdf' });

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(data, fileName);
      return;
    }

    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  get selected(): CompanySie | null {
    if (this.selectedModel.Created) {
      return this.selectedModel;
    } else {
      return null;
    }
  }

  get isActive() {
    if (!this.selected || !user.activeSie) {
      return false;
    }
    return this.selected.AggVersion === user.activeSie.AggVersion;
  }
}
